import { render, staticRenderFns } from "./SearchButtons.vue?vue&type=template&id=79c1e108&scoped=true&"
import script from "./SearchButtons.vue?vue&type=script&lang=ts&"
export * from "./SearchButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c1e108",
  null
  
)

export default component.exports